import { Injectable } from "@angular/core";
// store
import { Subject } from "rxjs";

// services
import { BookingService } from "./booking.service";
import { ErrorHandler } from '../../shared/services/error-handler.service';

declare var ApplePaySession;

@Injectable({
  providedIn: "root",
})
export class ApplePayService {
  public onPaymentSubmit$: Subject<boolean> = new Subject();
  private session = null;

  constructor(
    private _bookingService: BookingService,
    private _errorService: ErrorHandler
  ) {}

  handleApplePayEvents(session, total) {
    session.onvalidatemerchant = async (event) => {
      console.log("merchant validation", event);

      this._bookingService.validateApplePayMerchant(
        event.validationURL,
        (res: any) => {
          console.log("merchant validation complete", res);
          session.completeMerchantValidation(JSON.parse(res.session));
        }
      );
    };

    session.onpaymentmethodselected = (event) => {
      console.log("Payment Method Selected", event);

      const update = {
        newTotal: total,
      };

      session.completePaymentMethodSelection(update);
    };

    session.onshippingmethodselected = (event) => {
      console.log("onshippingmethodselected", event);

      const update = {};
      session.completeShippingMethodSelection(update);
    };

    session.onshippingcontactselected = (event) => {
      console.log("onshippingcontactselected", event);

      // const update = {};
      const update = {
        newTotal: total,
      };
      session.completeShippingContactSelection(update);
    };

    session.onpaymentauthorized = (event) => {
      console.log("Payment is authorized", event);

      this._bookingService.setApplePaymentToken(event.payment);

      this.onPaymentSubmit$.next(true);
    };

    session.oncancel = (event) => {
      console.log("Apple pay was canceled", event);

      const error = {
        text: "Payment cancelled. Please try again or select another payment method.",
        sticky: false,
      };
      this._errorService.handleCustomError(error);
    };
  }

  createSession(request, total_items) {
    this.session = new ApplePaySession(6, request);
    this.session.begin();
    this.handleApplePayEvents(this.session, total_items);
  }

  completePayment(result) {
    this.session.completePayment(result);
  }

  clearSession() {
    this.session = null;
  }
}
